import { ValueOf } from '../common/utils';

export const COUPON_STATUS_V2 = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
} as const;

export type COUPON_STATUS_V2 = ValueOf<typeof COUPON_STATUS_V2>;

export const COUPON_TYPE_V2 = {
  ALL_PRODUCT_LIST: 'allProducts',
  TARGET_PRODUCT: 'targetProduct',
  TARGET_STORE: 'targetStore',
} as const;

export type COUPON_TYPE_V2 = ValueOf<typeof COUPON_TYPE_V2>;

export const COUPON_PERIOD_TYPE_V2 = {
  FIXED_DATE: 'fixedDate',
  GENERATED_DATE: 'generatedDate',
  INFINITY: 'infinity',
} as const;

export type COUPON_PERIOD_TYPE_V2 = ValueOf<typeof COUPON_PERIOD_TYPE_V2>;

export const COUPON_DISCOUNT_TYPE_V2 = {
  AMOUNT: 'amount',
  RATE: 'rate',
} as const;

export type COUPON_DISCOUNT_TYPE_V2 = ValueOf<typeof COUPON_DISCOUNT_TYPE_V2>;
